import { RG70 } from "./CustomerGroupSales/RG70";
import { RG71 } from "./DistrictManager/RG71";
import { RG70_02 } from "./ProductSales/RG70_02";
import { RG69_01 } from "./ProductSalesPerf/RG69_01";
import { RG71_02 } from "./PMR/RG71_02";

export const RegionalCustomerGroupProduct = {
  "sections": [
    RG70,
    RG70_02,
    RG69_01,
    RG71,
    RG71_02
  ]
}